// extracted by mini-css-extract-plugin
export default {"mobile-padding":"16px","mobilePadding":"16px","nano-padding":"8px","nanoPadding":"8px","normal-padding":"20px","normalPadding":"20px","big-padding":"30px","bigPadding":"30px"};